import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a46bc28"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapContainer" }
const _hoisted_2 = {
  class: "p-3 container",
  id: "about"
}
const _hoisted_3 = { class: "row py-5" }
const _hoisted_4 = { class: "col-12 col-md-6 text-start" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Shayne Chang / 張雅琄", -1))
const _hoisted_6 = { class: "mt-4" }
const _hoisted_7 = {
  style: {"width":"24px","height":"24px"},
  viewbox: "0 0 24 24"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M17,19H7V5H17M17,1H7C5.89,1 5,1.89 5,3V21A2,2 0 0,0 7,23H17A2,2 0 0,0 19,21V3C19,1.89 18.1,1 17,1Z"
}, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" +886-975-769-025")
const _hoisted_11 = {
  style: {"width":"24px","height":"24px"},
  viewbox: "0 0 24 24"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M20,8L12,13L4,8V6L12,11L20,6M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z"
}, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" shaynec.0205@gmail.com")
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.$t("SECTION_TITLE.ABOUT")), 1),
          _hoisted_5,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$tm('ABOUT'), (about) => {
            return (_openBlock(), _createElementBlock("p", null, _toDisplayString(about), 1))
          }), 256)),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_9)),
            _hoisted_10
          ]),
          _createElementVNode("div", null, [
            (_openBlock(), _createElementBlock("svg", _hoisted_11, _hoisted_13)),
            _hoisted_14
          ])
        ]),
        _hoisted_15
      ])
    ])
  ]))
}